export const pathData = {
  0: {
    name: "Magic",
    videos: [
      {
        id: 0,
        type: "video/mp4",
        src: "/videos/1-1.mp4",
        title: "The past",
        textTracks: "/subtitles/magia/Magia_rozdzial_1_eng.vtt",
      },
      {
        id: 1,
        type: "video/mp4",
        src: "/videos/1-2.mp4",
        title: "The Displacement",
        textTracks: "/subtitles/magia/Magia_rozdzial_2_eng.vtt",
      },
      {
        id: 2,
        type: "video/mp4",
        src: "/videos/1-3.mp4",
        title: "The present",
        textTracks: "/subtitles/magia/Magia_rozdzial_3_eng.vtt",
      },
    ],
  },
  1: {
    name: "Home",
    videos: [
      {
        id: 3,
        type: "video/mp4",
        src: "/videos/2-1.mp4",
        textTracks: "/subtitles/dom/Dom_rozdzial_1_eng.vtt",
        title: "The past",
      },
      {
        id: 4,
        type: "video/mp4",
        src: "/videos/2-2.mp4",
        textTracks: "/subtitles/dom/Dom_rozdzial_2_eng.vtt",
        title: "The Displacement",
      },
      {
        id: 5,
        type: "video/mp4",
        src: "/videos/2-3.mp4",
        textTracks: "/subtitles/dom/Dom_rozdzial_3_eng.vtt",
        title: "The present",
      },
    ],
  },
  2: {
    name: "Community",
    videos: [
      {
        id: 6,
        type: "video/mp4",
        src: "/videos/3-1.mp4",
        textTracks: "/subtitles/spoleczenstwo/Spoleczenstwo_rozdzial_1_eng.vtt",
        title: "The past",
      },
      {
        id: 7,
        type: "video/mp4",
        src: "/videos/3-2.mp4",
        textTracks: "/subtitles/spoleczenstwo/Spoleczenstwo_rozdzial_2_eng.vtt",
        title: "The Displacement",
      },
      {
        id: 8,
        type: "video/mp4",
        src: "/videos/3-3.mp4",
        textTracks: "/subtitles/spoleczenstwo/Spoleczenstwo_rozdzial_3_eng.vtt",
        title: "The present",
      },
    ],
  },
  3: {
    name: "Childhood",
    videos: [
      {
        id: 9,
        type: "video/mp4",
        src: "/videos/4-1.mp4",
        textTracks: "/subtitles/dziecinstwo/Dziecinstwo_rozdzial_1_eng.vtt",
        title: "The past",
      },
      {
        id: 10,
        type: "video/mp4",
        src: "/videos/4-2.mp4",
        textTracks: "/subtitles/dziecinstwo/Dziecinstwo_rozdzial_2_eng.vtt",
        title: "The Displacement",
      },
      {
        id: 11,
        type: "video/mp4",
        src: "/videos/4-3.mp4",
        textTracks: "/subtitles/dziecinstwo/Dziecinstwo_rozdzial_3_eng.vtt",
        title: "The present",
      },
    ],
  },
};
